import React from "react";
import {Slide} from "@material-ui/core";

export function SlideDown(props: any) {
    return <Slide direction="down" {...props} />;
}